import axios from "axios";
import { header } from "./header";

export const GetPartyListForTrans = async (obj) => {
     var isAnonymousUser = obj.isAnonymousUser === true?true:false
  try {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/PartyMaster/GetPartyListForTransactions?OrgCode=${obj.orgCode}&PartyType=${obj.partyType}&lStart=${obj.startValue}&lEnd=${'5000'}&isOverSeas=${obj.isOverSeas}&isAnonymousUser=${isAnonymousUser}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const getInvoiceTransactionList = async (invoicetype) => {
  const orgCode = localStorage.getItem('OrgCode');
  const subOrgCode =  sessionStorage.getItem('branchCodeInStockLevel') !== null ? sessionStorage.getItem('branchCodeInStockLevel') : localStorage.getItem('LocCode');//localStorage.getItem('LocCode');
  const type = invoicetype;
  const start = 0;
  const end = 1000;
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetTransationsList?OrgCode=${orgCode}&SubOrgCode=${subOrgCode}&Type=${type}&start=${start}&end=${'10000'}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const getInvoiceBillsTransactionList = async (invoicetype) => {
  const orgCode = localStorage.getItem('OrgCode');
  const subOrgCode =  sessionStorage.getItem('branchCodeInStockLevel') !== null ? sessionStorage.getItem('branchCodeInStockLevel') : localStorage.getItem('LocCode');//localStorage.getItem('LocCode');
  const type = invoicetype;
  const start = 0;
  const end = 1000;
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetTransactionsListForReports?orgCode=${orgCode}&subOrgCode=${subOrgCode}&transactionType=${type}&start=${start}&end=${'10000'}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const getInvoiceTransactionList1 = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetTransationsList?OrgCode=${obj.orgCode}&SubOrgCode=${obj.subOrgCode}&Type=${obj.type}&start=${obj.start}&end=${obj.end}&pageNo=${obj.currentPage}&pagesize=${obj.pageSize} &Search=${obj.searchVal}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const getInvoicebranchtransfer = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetTransationsList?OrgCode=${obj.orgCode}&SubOrgCode=${obj.subOrgCode}&Type=${obj.type}&start=${obj.start}&end=${obj.end}&pageNo=${obj.currentPage}&pagesize=${obj.pageSize}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const deleteInvoiceTransactionList = async (transactionNo, id, orgCode, subOrgCode) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/DeleteTransaction?OrgCode=${orgCode}&SubOrgCode=${subOrgCode}&TransactionNo=${transactionNo}&TransactionId=${id}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const getLocationBranchDetails = async (PartyId, OrgCode) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/PartyMaster/GetLocationBranchDetailsByPartyId?PartyId=${PartyId}&OrgCode=${OrgCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const getTaxCalculation = async (taxObj,obj) => {
  if(obj){
    var RegistrationStatus  = obj.RegistrationStatus;
    var isTransactionTyepIsPurchase  = obj.isTransactionTyepIsPurchase;
  }else{
   var RegistrationStatus  =0;
    var isTransactionTyepIsPurchase  = false;
  }
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetTaxCalculation?isTransactionTyepIsPurchase=${isTransactionTyepIsPurchase}&RegistrationStatus=${RegistrationStatus}`, taxObj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const getTransactionDetails = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/AddTransactionDetails`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const getTransactionItemDetails = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/AddtransactionItemDetails`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const getAddInvoicePartyMappingDetails = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/AddInvoicePartyMappingDetails`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const getAddInvoiceSummaryDetails = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/AddInvoiceSummaryDetails`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const updateorderstatus = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/UpdateOrderStatus?OrderId=${obj.OrderId}&TransactionId=${obj.TransactionId}&InvoiceId=${obj.InvoiceId}&Type=${obj.Type}&OrgCode=${obj.OrgCode}&SubOrgCode=${obj.SubOrgCode}`,'',{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const updatequotationstatus = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/UpdateQuotationOnInvoiceGeneration?QuoteId=${obj.QuoteId}&InvoiceId=${obj.InvoiceId}&OrgCode=${obj.OrgCode}&SubOrgCode=${obj.SubOrgCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const getTransactionDetailForInvoice = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetTransactionDetailForInvoice?TransactionNumber=${Obj.TransactionNumber}&TransactionId=${Obj.TransactionId}&OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const getTransactionDetailForJournal = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetTransactionDetails?InvoiceNo=${Obj.TransactionNo}&TransactionType=${Obj.TransactionType}&OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const getItemDetails = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/GetItemList?OrgCode=${Obj.OrgCode}&fromdate=${Obj.fromdate}&todate=${Obj.todate}&start=${Obj.start}&count=${'5000'}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}


export const deleteTransactionItem = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/DeleteTransaction?OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}&TransactionNo=${Obj.TransactionNo}&TransactionId=${Obj.TransactionId}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}


export const generateINR = async (Obj) => {
  try {
    let response;
    JSON.parse(localStorage.getItem("isUAElogin")) ? 
    response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/UAEEInvoice/GenerateUAEEInvoice`, Obj,{headers:header()}):
    response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GenerateIRNNumber`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}


export const cancelIRNNumber = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/CancelIRNNumber`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const CancelTransaction = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/CancelTransaction?OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}&TransactionIds=${Obj.TransactionIds}&IsCancel=${Obj.IsCancel}&TransactionType=${Obj.TransactionType}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}


export const GetItemListForTransactionWithPagination = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/GetItemListForTransactionWithPagination?OrgCode=${Obj.OrgCode}&LStart=${Obj.LStart}&LEnd=${'5000'}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const GetItemListForTransactionsWithPagination = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/GetItemListForTransactionsWithPagination?OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}&TransactionType=${Obj.TransType}&LStart=${Obj.LStart}&LEnd=${'50000'}&itemsku=${Obj.itemsku}&partyId=${Obj.partyid || 0}&barcode=${Obj.barcode || ""}&SelectedUOM=${Obj.SelectedUOM || ""}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const getbundleproductsdata = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/CheckInventory`,Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const getBArcodeList = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/GetItemBarcodeList?OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}&LStart=${Obj.LStart}&LEnd=${Obj.LEnd}&Search=${''}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const CudInventory = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/CUDInventory`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const GetInventoryQtyForTransactions = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/GetInventoryQtyForTransactions?ItemSku=${Obj.item}&OrgCode=${Obj.org}&OrgBranchCode=${Obj.subOrg}&BaseUOM=${Obj.BaseUOM}&SelectedUOM=${Obj.SelectedUOM}&GroupName=${Obj.GroupName}&BatchNo=${Obj.BatchNo}&LotNo=${Obj.LotNo}&SerialNo=${Obj.SerialNo}&TransactionDate=${Obj.TransactionDate}&StockRoomId=${Obj.StockRoomId || 0}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const GetInventoryQtyListForTransactions = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/GetInventoryQtyListForTransactionsSP`,Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const GetInvConvertedQty = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/GetInvConvertedQty?OrgCode=${Obj.org}&ItemSku=${Obj.item}&TargetUOMName=${Obj.Tname}&TargetUOMId=${Obj.Tid}&suborgcode=${Obj.subOrg}&GroupId=${Obj.Gid}&InvQty=${Obj.qty}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const GetItemUOMConversions = async (orgCode, itemSku) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/GetItemUOMConversions?OrgCode=${orgCode}&ItemSku=${itemSku}&IncludeInactive=false`, {headers: header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const GetAccountsListForTransaction = async (OrgCode, TransactionType) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/GetAccountsListForTransactions?OrgCode=${OrgCode}&TransactionType=${TransactionType}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const CancelOrDeleteInventory = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/CancelOrDeleteTransactionInventory?Ids=${Obj.Ids}&OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}&Cancel=${Obj.Cancel}&Delete=${Obj.Delete}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const CancelOrDeleteInvoice = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/CancelInvoiceListScreen?TransactionNos=${Obj.TransactionNos}&OrgCode=${Obj.OrgCode}&OrgBranchcode=${Obj.OrgBranchcode}&IsCancel=${Obj.IsCancel}&IsDelete=${Obj.IsDelete}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const deleteMultipleTransaction = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/DeleteMultipleTransaction?OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}&TransactionIds=${Obj.TransactionIds}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const CancelPosTransaction = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/CancelPosTransaction?OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}&TransactionNo=${Obj.TransactionNo}&TransactionId=${Obj.TransactionId}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}



export const SavePostings = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/AddAccountingEffects`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const getOrgDetails = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}Organisation/GetOrgDetails?OrgCode=${obj.orgCode}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}


export const getSubOrgList = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/OrgAPI/GetSubOrgList?OrgCode=${obj.orgCode}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}
export const GetLocationListByUserId = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/UserAPI/GetLocationListByUserId?UserName=${obj.UserName}&OrgCode=${obj.OrgCode}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}
export const getOrgprofile = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/OrgAPI/GetOrgList?OrgCode=${obj.orgCode}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}


export const sendInvoiceEmail = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/SendInvoiceInMail`, obj,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}
export const newlocationAdd = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/OrgAPI/AddLocation`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const updatelocation = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/OrgAPI/EditLocation`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const getserialnumbers = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/GetItemBatchSerial?ItemSKu=${obj.ItemSKu}&OrgCode=${obj.OrgCode}&OrgBranchCode=${obj.OrgBranchCode}&Type=${obj.SerialType}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}
export const AddnewUser = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/UserAPI/AddNewUser`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const Addnewgroup = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/UserAPI/AddGroups`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const updateUserdata = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/UserAPI/UpdateUser`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const getUsers = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/UserAPI/GetUserList?OrgCode=${obj}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}
export const getuserprofile = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/UserAPI/GetUserDetails?Id=${obj.Id}&OrgCode=${obj.OrgCode}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}
export const getgroupdetails = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/UserAPI/GetGroupDetails?Id=${obj.Id}&OrgCode=${obj.OrgCode}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}
export const camparaPassword = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/UserAPI/CompareExistingPassword`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

// TDS && ADJ DropDown Values SERVICE

export const GetGLAccountsList = async (code) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/GetGLAccountsList?OrgCode=${code}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}



export const GetAccountingEffectsForInvoice = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/GetTDSAccountingEffectsForInvoice?TransactionNo=${Obj.TransactionNumber}&&TransactionType=${Obj.TransactionType}&OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}


export const Transactiondeleteposting = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsPosting/DeletePostings?TransactionNo=${Obj.TransactionNo}&&TransactionType=${Obj.TransactionType}&OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}
export const deleteUser = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/UserAPI/DeleteUser`, obj,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}

export const GetCreditsListAganistParty = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/OtherTransactions/GetCreditsListAganistParty?OrgCode=${obj.OrgCode}&PartyCode=${obj.PartyCode}&TransactionType=${obj.TransactionType}`,{headers:header()})
    return response;
  }
  catch (error) {
    return error.response
  }
}

export const SavePartyCredits = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/OtherTransactions/SavePartyCreditsAllocation`, obj,{headers:header()})
    return response
  }
  catch (error) {
    return error.response
  }
}
export const VerifyOrderFulfiled = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/VerifyOrderFulfiled?OrgCode=${obj.OrgCode}&SubOrgCode=${obj.SubOrgCode}&Id=${obj.Id}&Type=${obj.Type}`,{headers:header()})
    return response;
  }
  catch (error) {
    return error.response
  }
}

export const Addaddationaldetails = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/AddAddtionalFieldsContentDetails`, obj,{headers:header()})
    return response
  }
  catch (error) {
    return error.response
  }
}


export const holdInventory = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/HoldInventory`, Obj,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}


export const SUPWorkflowStatus = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/SaveOrUpdateWorkflowStatus`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const OmsGeneratetrans = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/TaxCalculationForOMS`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const PhysicalLocationInventory = async (code) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/PhysicalLocationInventory?OrgCode=${code}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const getTransactionSummaryByParty = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetTransactionSummaryByParty?transactionType=${obj.transactionType}&orgCode=${obj.orgCode}&subOrgcode=${obj.subOrgcode}&partyCode=${obj.partyCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const UpdateLoginData = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/AddUpdateEInvoiceCredentials`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const getLoginData = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetEInvoiceClientCredentails?OrgCode=${obj.OrgCode}&SubOrgCode=${obj.SubOrgCode}&CredentialsType=${obj.CredentialsType}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}


export const getEInvoiceList = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetEInvoiceList?OrgCode=${obj.OrgCode}&SubOrgCode=${obj.SubOrgCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const GetEInvoiceByteCode = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetEInvoiceByteCode?OrgCode=${Obj.OrgCode}&IrnNumber=${Obj.IrnNumber}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const GetEWayBillByteCode = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetEWayBillByteCode?OrgCode=${Obj.OrgCode}&EWayBillNo=${Obj.EWayBillNo}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const GetEWayBillBytesingleCode = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetEWayBillOnlyByteCode?OrgCode=${Obj.OrgCode}&EWayBillNo=${Obj.EWayBillNo}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const generateewaybill = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GenerateEWayBill`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const GenerateEWayBillsingle = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GenerateEwayBillOnly`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const  SingleCancelEwB= async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/CancelEwayBills?OrgCode=${localStorage.getItem('OrgCode')}&SubOrgCode=${localStorage.getItem('LocCode')}`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const GetTransactiondateForLedger = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetTransactiondateForLedger?OrgCode=${Obj.OrgCode}&DeactivationDate=${Obj.Deactivationdate}&ledgerId=${Obj.id}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const GetOrgBankDataList = async (OrgCode) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_ACCOUNT_MASTER_URL}/api/AccountsMaster/GetOrgBankDataList?OrgCode=${OrgCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const AllcoateCreditsByTransactionId = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/LedgerTransaction/AllcoateCreditsByTransactionId`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const checkdocseries = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/DocSeriesValidations?OrgCode=${obj.orgCode}&OrgBranchCode=${obj.subOrgCode}&TransType=${obj.type}&TransDate=${obj.TransDate}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const checkvaliddocseries = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/DocPatternValidations?OrgCode=${obj.orgCode}&OrgBranchCode=${obj.subOrgCode}&TransType=${obj.type}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const VerifylotSeriesNo = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/VerifylotSeriesNo?OrgCode=${obj.OrgCode}&SubOrgcode=${obj.SubOrgcode}&LOTSerialNo=${obj.LOTSerialNo}&IsSerialization=${obj.IsSerialization}&TransactionId=${obj.TransactionId}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const CheckUpdatedInventoryForItemSKU = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/CheckUpdatedInventoryForItemSKU`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const GetStockroomWiseReturnQty = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/OtherTransactions/GetStockRoomWiseNewQtyForInvoiceReturns?OrgCode=${obj.OrgCode}&OrgBranchCode=${obj.OrgBranchCode}&InvoiceId=${obj.InvoiceId}&ItemSku=${obj.ItemSku}&Uom=${obj.Uom}&Conversionvalue=${obj.Conversionvalue}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const GetItemQtyForStockRoom = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/GetItemQtyForStockRoom?orgcode=${Obj.orgcode}&orgbranchcode=${Obj.orgbranchcode}&stockroomid=${Obj.stockroomid}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const GetPhysicalLocationIdForStockRoom = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/GetPhysicalLocationIdForStockRoom?orgcode=${Obj.orgcode}&orgbranchcode=${Obj.orgbranchcode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const spiltOrderSave =async(obj)=>{
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/CreateSplitOrder`,obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const PostTransactions=async(Obj)=>{
  try{
    const response=await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/PostTransactionCalls`, Obj,{headers:header()})
    return response;
  }  catch(error){
    return error.response
  }
}
 

export const GetItemListForPhysicalLocation = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/GetItemListForPhysicalLocation?orgcode=${Obj.orgcode}&orgbranchcode=${Obj.orgbranchcode}&partyid=${Obj.partyid || 0}&TransactionDate=${Obj.TransactionDate}&CategoryId=${Obj.CategoryId}&BrandId=${Obj.brandId || 0}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}


export const UaeVatCalculator = async (taxObj,type) => {
  var registerType=(type!==null && type!==undefined && type!=='') ? type: JSON.parse(localStorage.getItem("VATRegisteredType"))
  try {
    const response = await axios.post(`${process.env.REACT_APP_CATAX_URL}/api/UaeVatCalculator/UAETaxCalculation?RegType=${registerType}`,taxObj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const TotalInvoiceAmountForUAEtemplate = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/TotalInvoiceAmountForUAEtemplate?orgcode=${Obj.orgcode}&SubOrgCode=${Obj.suborgcode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const TransactioncountforDisableLocationcode = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}Organisation/TransactioncountforDisableLocationcode?OrgCode=${Obj.orgcode}&SubOrgcode=${Obj.orgbranchcode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const GetAll = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/Salesman/GetAll?OrgCode=${obj.orgcode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const DCtaxCalculator = async (taxObj,type) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/TaxCalculationForItems`,taxObj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}
export const Savechallan = async (taxObj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/DeliveryChallan/SaveOrUpdateDeliveryChallan`,taxObj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const getDeliverchallan = async (OrgCode,SubOrgCode,type) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/DeliveryChallan/GetDeliveryChallans?OrgCode=${OrgCode}&SubOrgCode=${SubOrgCode}&DelivaryType=${type}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}
export const GetDeliveryChallanById = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/DeliveryChallan/GetDeliveryChallanById?SubOrgCode=${obj.SubOrgCode}&DeliveryChallanId=${obj.DeliveryChallanId}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}

export const UpdateReceivedStatus = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/DeliveryChallan/UpdateReceivedStatus`,Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const getDeliverchallanbypartiesbased = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/DeliveryChallan/GetDeliveryChallanByParty`,obj,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}
export const getdeliverychallanlistsbysingleInvoice = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/CreateInvoiceFromListOfDeliveryChallans`,obj,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}

export const GetUserShiftSummaryReport = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetUserShiftSummaryReport?orgCode=${obj.orgCode}&fromDate=${obj.fromDate}&toDate=${obj.toDate}&userId=${obj.userId}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}

export const Printshippingdocument = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/PrintShippingDocument?TransactionId=${obj.TransactionId}&orgCode=${obj.orgCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const CheckTransactionExistsornot = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/CheckTransactionExistsornot?transactionId=${obj.TransactionId}&orgCode=${obj.orgCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const SwitchUserLoginLogout = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/OrgApi/SwitchUserLoginLogout`,obj,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}
export const GetAvailableQtyForReturn = async (obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/GetAvailableQtyForReturn?OrgCode=${obj.OrgCode}&SubOrgCode=${obj.SubOrgCode}&RefTransactionId=${obj.RefTransactionId}&UOM=${obj.UOM}&ItemSku=${obj.itemSku}`,{headers:header()});
    return response;
  }
  catch (error) {
    return error.response
  }
}
export const getBArcodeListbypurchaseTransaction = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/GetItemBarcodeListByInvoice?OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}&PurchaseInvoiceId=${Obj.PurchaseInvoiceId}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const GetBatches = async (Obj) => {
  try {
    
    const response = await axios.get(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/GetBatches?OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}&ItemSku=${Obj.ItemSku}&OnlyAvailable=${Obj.OnlyAvailable}&IncludeExpired=${Obj.IncludeExpired}&WarehouseId=${Obj.WarehouseId}&UOM=${Obj.UOM}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response;
  }
}

export const GetBatchMasterList = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/GetBatchMasterList?orgCode=${Obj.orgCode}&subOrgCode=${Obj.subOrgCode}`, { headers: header() });
    return response;
  } catch (error) {
    return error.response;
  }
}

export const BulkUpdateBatchPricing = async (Obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/BulkUpdateBatchPricing`, Obj, { headers: header() });
    return response;
  } catch (error) {
    return error.response;
  }
}